import { IUigpConfigurationItem } from "./constants";

export const actionTypes = {
  ADMIN_UIGP_CONFIG_REQUEST: "ADMIN_UIGP_CONFIG_REQUEST",
  ADMIN_UIGP_CONFIG_REQUEST_SUCCESS: "ADMIN_UIGP_CONFIG_REQUEST_SUCCESS",
  ADMIN_UIGP_CONFIG_REQUEST_FAILURE: "ADMIN_UIGP_CONFIG_REQUEST_FAILURE",
  ADMIN_UIGP_CONFIG_UPDATE_REQUEST: "ADMIN_UIGP_CONFIG_UPDATE_REQUEST",
  ADMIN_UIGP_CONFIG_UPDATE_REQUEST_SUCCESS:
    "ADMIN_UIGP_CONFIG_UPDATE_REQUEST_SUCCESS",
  ADMIN_UIGP_CONFIG_UPDATE_REQUEST_FAILURE:
    "ADMIN_UIGP_CONFIG_UPDATE_REQUEST_FAILURE",
};

export const fetchUgipConfig = () => ({
  type: actionTypes.ADMIN_UIGP_CONFIG_REQUEST,
});
export const fetchUgipConfigSuccess = (payload: any) => ({
  type: actionTypes.ADMIN_UIGP_CONFIG_REQUEST_SUCCESS,
  payload,
});
export const fetchUgipConfigFailure = (error: any) => ({
  type: actionTypes.ADMIN_UIGP_CONFIG_REQUEST_FAILURE,
  error,
});

export const updateUgipConfig = (payload: IUigpConfigurationItem) => ({
  type: actionTypes.ADMIN_UIGP_CONFIG_UPDATE_REQUEST,
  payload,
});
export const updateUgipConfigSuccess = (res: any) => ({
  type: actionTypes.ADMIN_UIGP_CONFIG_UPDATE_REQUEST_SUCCESS,
  res,
});
export const updateUgipConfigFailure = (error: any) => ({
  type: actionTypes.ADMIN_UIGP_CONFIG_UPDATE_REQUEST_FAILURE,
  error,
});
